import { isEqualNumberArray as r } from "../../utils/array/index2.js";
import { getLinesFromPolygon as m } from "./index9.js";
function y(n, t) {
  if (n.length !== t.length)
    return !1;
  const s = m(n), i = m(t), u = s.every((e) => i.some((o) => r(e[0], o[0]) && r(e[1], o[1]))), c = i.every((e) => s.some((o) => r(o[0], e[0]) && r(o[1], e[1])));
  return u && c;
}
export {
  y as arePolygonEqual
};
//# sourceMappingURL=index3.js.map
